import { get, post, del } from ".";

let membersPromise = {};
let contractorsPromise = {};

export const getMembersApi = async (projectId) => {
  if (membersPromise[projectId]) {
    return membersPromise[projectId];
  }
  membersPromise[projectId] = get(`project/${projectId}/members`)
    .then((data) => {
      return data;
    })
    .finally(() => {
      membersPromise[projectId] = null;
    });
  return membersPromise[projectId];
};

export const getContractorsApi = async (projectId) => {
  if (contractorsPromise[projectId]) {
    return contractorsPromise[projectId];
  }
  contractorsPromise[projectId] = get(`project/${projectId}/members/contractors`)
    .then((data) => {
      return data;
    })
    .finally(() => {
      contractorsPromise[projectId] = null;
    });
  return contractorsPromise[projectId];
};

// export const getMembersApi = async (projectId) => {
//   return await get(`project/${projectId}/members`);
// };

// export const getContractorsApi = async (projectId) => {
//   return await get(`project/${projectId}/members/contractors`);
// };

export const removeMembersApi = async (projectId, project_user_id) => {
  return await del(`project/${projectId}/members/remove-member?project_user_id=${project_user_id}`);
};

export const addOrUpdateMembersApi = async (projectId, params) => {
  return await post(`project/${projectId}/members/add-member`, params);
};

export const addContractorApi = async (projectId, params) => {
  return await post(`project/${projectId}/members/add-contractor`, params);
};

export const updateContractorApi = async (projectId, params) => {
  return await post(`project/${projectId}/members/update-contractor`, params);
};

export const removeContractorApi = async (projectId, projectContractorId) => {
  return await del(`project/${projectId}/members/remove-contractor?projectContractorId=${projectContractorId}`);
};

export const updatePermissionApi = async (projectId, project_user_id, accessLevel, editRight, reportModule, costAccess) => {
  return await post(`project/${projectId}/members/update-permission?project_user_id=${project_user_id}&accessLevel=${accessLevel}&editRight=${editRight}&reportModule=${reportModule}&costAccess=${costAccess}`);
};